// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.logc-error-center-screen[data-v-ebb5e4e8] {\n    margin-top: 15%;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
